import { useEffect, useRef } from "react";
import api from "@/lib/api";

/**
 * Polls navigator.geolocation every `intervalMs` and POSTs to /api/drivers/me/position.
 * Silent failure (geolocation denied or backend error doesn't show user-facing error).
 */
export default function useDriverGeoPing({ enabled = true, intervalMs = 30_000 } = {}) {
  const timerRef = useRef(null);
  const lastSent = useRef(0);

  useEffect(() => {
    if (!enabled) return;
    if (!("geolocation" in navigator)) return;

    const send = () => {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          const now = Date.now();
          if (now - lastSent.current < intervalMs * 0.8) return;
          lastSent.current = now;
          try {
            await api.post("/drivers/me/position", {
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
            });
          } catch {}
        },
        () => {},
        { enableHighAccuracy: false, maximumAge: 20_000, timeout: 8_000 }
      );
    };

    send();
    timerRef.current = setInterval(send, intervalMs);
    return () => clearInterval(timerRef.current);
  }, [enabled, intervalMs]);
}
